<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Factures
        <span class="separator" />
      </h1>
    </b-col>
    <ListeFactures />
  </div>
</template>

<script>
import ListeFactures from "@/components/libraires/factures/ListeFactures.vue";

export default {
  name: "Factures",
  components: {
    ListeFactures,
  },
};
</script>
<style lang="scss" scoped></style>
